import { useEffect, useState } from "react";
import { PageHeader, StatusPill, fmtINR } from "./Primitives";
import { supabase } from "@/lib/supabase";
import { useAuth } from "@/lib/auth";
export function LivePortalPage({
  title,
  description,
  table,
  columns,
  filterField = "user_id",
  select = "*",
}: any) {
  const { user } = useAuth();
  const [r, setR] = useState<any[]>([]);
  useEffect(() => {
    if (!user) return;
    supabase
      .from(table)
      .select(select)
      .eq(filterField, user.id)
      .order("created_at", { ascending: false })
      .then((x) => setR(x.data || []));
  }, [user, table]);
  return (
    <div className="space-y-6">
      <PageHeader title={title} description={description} />
      <div className="space-y-2">
        {r.map((x) => (
          <div
            className="rounded-xl border border-border bg-card p-4"
            key={x.id}
          >
            {columns.map((c: any) => (
              <div key={c.key} className="flex justify-between gap-4 py-1">
                <span className="text-xs text-muted-foreground">{c.label}</span>
                <span>{c.render ? c.render(x) : String(x[c.key] ?? "—")}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}